module.exports = __webpack_public_path__ + "img/inspiration_01.10c45a0.webp";